<script setup>
// import { defineOptions } from 'vue';

// defineOptions({
//   inheritAttrs: false,
// });
</script>
<template>
  <div class="flex-1 flex flex-col gap-4">
    <component
      v-for="(i, index) in $attrs.ui"
      is="Row"
      :key="index"
      v-bind="i"
    />
  </div>
</template>

<script>
import Row from './Row.vue';
import TSelect from './TSelect.vue';
import TSeparator from './TSeparator.vue';
import TUploads from './TUploads.vue';
export default {
  inheritAttrs: false,
  components: {
    Row,
    TSelect,
    TSeparator,
    TUploads,
  },
};
</script>

<style lang="scss" scoped></style>
